import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class BpjsReportProvider {

  private _service: string = 'payroll';
  private _model: string = 'bpjsreport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadtksummary(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadtksummary';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public downloadtk(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadtk';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }

  public downloadks(filter: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadks';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof filter !== 'undefined' && filter !== null) _urlParams.filter = filter;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlobWithProgress(_method, _url, _func, _params, _body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/bpjs-report/bpjs-report.ts